import {LngLat} from '@yandex-int/ymaps3-react/deprecated'

const DEFAULT_OPTIONS: PositionOptions = {
  enableHighAccuracy: true,
  maximumAge: 60 * 1000, // 60 секунд кэша
  timeout: 10 * 1000 // 10 секунд на выполнение
}

export const getGeolocationFromBrowser = (): Promise<LngLat> =>
  new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      ({coords}) => resolve([coords.longitude, coords.latitude]),
      reject,
      DEFAULT_OPTIONS
    )
  })

export const getGeolocationPermission = (): Promise<PermissionStatus> => {
  if (!navigator.permissions) {
    return Promise.reject()
  }

  return new Promise((resolve, reject) => {
    navigator.permissions.query({name: 'geolocation'}).then(resolve).catch(reject)
  })
}
